import { motion } from "framer-motion";
import { Bot } from "lucide-react";

const TEAM = [
  { initials: "AO", name: "Amara Osei", role: "Contracts Director", note: "15 years in commercial hygiene" },
  { initials: "LC", name: "Leigh Cartwright", role: "Operations Supervisor", note: "Night-shift & event turnarounds" },
  { initials: "PN", name: "Priya Nair", role: "Quality & Compliance Lead", note: "ISO 9001 audit owner" },
];

export const Team = () => (
  <section
    id="team"
    data-testid="team-section"
    className="relative py-24 sm:py-28 border-t border-white/5"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12 flex items-end justify-between flex-wrap gap-6"
      >
        <div>
          <p className="eyebrow mb-4">The People Behind The Polish</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ice-50 leading-snug">
            A small team, <span className="text-gold-500">deliberately.</span>
          </h2>
        </div>
        <span
          data-testid="team-sample-badge"
          className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-500 border border-gold-500/40 rounded-full px-4 py-1.5"
        >
          Sample Only
        </span>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {TEAM.map((t, i) => (
          <motion.div
            key={t.name}
            data-testid={`team-card-${t.initials.toLowerCase()}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
            className="group bg-navy-800/50 border border-white/5 rounded-xl p-7 hover:border-gold-500/30 transition-colors duration-300"
          >
            <span className="w-14 h-14 rounded-full bg-navy-700 border border-gold-500/30 grid place-items-center font-display font-extrabold text-gold-400 text-lg mb-5 transition-transform duration-300 group-hover:scale-105">
              {t.initials}
            </span>
            <h3 className="font-heading font-semibold text-lg text-ice-50">{t.name}</h3>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-gold-500/80 mt-1 mb-3">{t.role}</p>
            <p className="text-xs text-ice-200/50 leading-relaxed">{t.note}</p>
          </motion.div>
        ))}

        <motion.div
          data-testid="team-card-goldie"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.55, delay: 0.28 }}
          className="relative bg-gradient-to-b from-gold-500/15 to-navy-800/60 border border-gold-500/40 rounded-xl p-7 overflow-hidden"
        >
          <span className="absolute top-4 right-4 font-mono text-[9px] uppercase tracking-[0.18em] text-emerald-400 flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Always On
          </span>
          <span className="w-14 h-14 rounded-full bg-gold-500 grid place-items-center mb-5">
            <Bot className="w-7 h-7 text-navy-900" />
          </span>
          <h3 className="font-heading font-semibold text-lg text-ice-50">Goldie</h3>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-gold-400 mt-1 mb-3">
            AI Receptionist
          </p>
          <p className="text-xs text-ice-200/60 leading-relaxed">
            Answers questions and books quotes around the clock — try the chat in the corner.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
